import reactComponentLoader from 'scripts/react-component-loader'

import Error500 from './Error500'

reactComponentLoader(Error500, '[data-page-error-500]')
